import _Model from "./_Model";

export default class Rule extends _Model {
  constructor(json) {
    super(json);
    const {
      name = '???',
      constraintGroup = 'none',
      ...payload
    } = (json || {});

    this.name = name;
    this.constraintGroup = constraintGroup.toLowerCase();
    this.payload = payload;
  }

}
